import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import ApprovalTerms from '@sunbit-dev/ui/src/components/card-apply/pages/approvalTerms/ApprovalTerms';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadApplicationDocumentThunk } from '../actions/applicationDocumentsActions';
import { selectApplicationCreditScoreNotice, selectCreditLineDetails } from '../selectors';
import { useMixpanel } from '../services/mixpanel/mixPanel';
import { MixpanelCardApplylEvent } from '@sunbit-dev/common/enums/cardApply/MixpanelCardApplylEvent';
import { useEffect } from 'react';
import { submitAcceptOffer } from '../actions/approvalTermsActions';

const ApprovalTermsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { trackForMixPanel } = useMixpanel();
  React.useEffect(() => {
    dispatch(loadApplicationDocumentThunk(DocumentTypesTypes.CardApplicationCreditScoreNotice));
  }, [dispatch]);
  const creditScoreNoticeDocument = useSelector(selectApplicationCreditScoreNotice);

  const creditLineDetails = useSelector(selectCreditLineDetails);
  const handleContinue = React.useCallback(() => {
    dispatch(submitAcceptOffer());
  }, [dispatch]);
  useEffect(() => {
    trackForMixPanel(MixpanelCardApplylEvent.PreApproved_Views);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ApprovalTerms
      creditScoreNoticeDocument={creditScoreNoticeDocument}
      {...creditLineDetails}
      continue={handleContinue}
    />
  );
};

export default ApprovalTermsContainer;
